import type React from 'react';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';
import { ButtonLink } from '@change-corgi/design-system-legacy/components/actions';
import { WordMark } from '@change-corgi/design-system-legacy/components/brand';
import { Box, Container, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import type { LandingPageSlug } from 'src/app/pages/landing/template/shared/types';

type Props = {
	slug: LandingPageSlug;
	onCtaClick: () => void;
};

export const Header: React.FC<Props> = ({ onCtaClick, slug }) => {
	const { translate } = useI18n();

	return (
		<Box sx={{ position: 'relative' }}>
			<Box sx={{ position: 'absolute', width: '100%', left: 0, top: [8, 24] }}>
				<Container px={[16, 0]}>
					<Flex sx={{ alignItems: 'center' }}>
						<WordMark
							color="primary-white"
							size={['default', 'huge']}
							// necessary to align the logo
							sx={{ transform: ['translateY(4px)', 'translateY(6px)'] }}
						/>
						<Text color="primary-white" ml={8} size={['default', 'huge']}>
							<Translate value={`landing.${slug}.logo_header`} />
						</Text>
					</Flex>
				</Container>
			</Box>
			<Box
				sx={{
					backgroundImage: `url(${translate(`landing.${slug}.assets.hero`)})`,
					backgroundPosition: 'center center',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					width: '100%',
					height: [334, 576],
				}}
			></Box>
			<Box px={[16, 64]}>
				<Box
					sx={{
						backgroundColor: 'primary-greyBackground',
						maxWidth: [330, 775],
						borderRadius: 'standard',
					}}
					mx="auto"
					mt={[-140, -240]}
					px={[24, 64]}
					py={[16, 32]}
				>
					<Heading
						as="h1"
						size={['h2', 'h1']}
						sx={{
							textAlign: 'center',
						}}
					>
						<Translate value={`landing.${slug}.cta_header.title`} />
					</Heading>
					<Text as="p" sx={{ textAlign: 'center' }} size={['large', 'huge']} mt={15}>
						<Translate value={`landing.${slug}.cta_header.body`} />
					</Text>
					<Flex sx={{ alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
						<ButtonLink
							onClick={onCtaClick}
							to={`/start-a-petition?source_location=${slug}_landing_page`}
							sx={{ width: ['100%', 322] }}
							mt={40}
						>
							<Translate value={`landing.${slug}.cta_header.button`} />
						</ButtonLink>
					</Flex>
				</Box>
			</Box>
		</Box>
	);
};
